<nav main-navigation class="organizer-shared-layout-dashboard-navigation">
  <ul class="organizer-shared-layout-dashboard-navigation__list">
    <li
      class="organizer-shared-layout-dashboard-navigation__list__item"
      *ngFor="let linkConfig of linksConfig"
    >
      <a
        class="navigation-link"
        [routerLinkActive]="['navigation-link--active']"
        [routerLink]="linkConfig.routerLink | localize"
      >
        <span class="navigation-link__icon-section">
          <vtmn-play-icon
            [name]="linkConfig.iconName"
            class="navigation-link__icon-section__icon"
          ></vtmn-play-icon>
          <span
            *ngIf="linkConfig.totalNotifications > 0"
            class="navigation-link__icon-section__notification"
          >
            {{ linkConfig.totalNotifications }}
          </span>
        </span>
        {{ linkConfig.labelKey | translate }}
      </a>
    </li>
  </ul>
</nav>
